import {BaseClient} from "./BaseClient";
import {Result} from "./Result";


export interface BucketMapping {
    id: string,
    mpans: string[]
}


export class DfsClient {
    baseClient: BaseClient

    constructor(baseClient: BaseClient) {
        this.baseClient = baseClient
    }

    async retrieveDFSBuckets(): Promise<Result<BucketMapping[]>> {
        return await this.baseClient.getOkP<BucketMapping[]>(`/api/bucket?programme=DFS`)
    }
}
